var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["combineReducers"]: function() { return __WEBPACK_EXTERNAL_MODULE_redux_immutable_446c9f82__.combineReducers; } });